"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportClient = useExportClient;
const ExportClient_1 = require("@juvare/platform-sdk-js/ExportClient");
const react_1 = __importDefault(require("react"));
function useExportClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new ExportClient_1.ExportClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
